define('drops/boolInput/boolInput',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/constants'
], function ($, Drop, Style, util, constants) {
	'use strict';

    var defaults = {
        data: {
            useBuiltInStyle: true
        }
    };

    function BoolInput(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.renderCheckbox();

        this.$element
            .css({
                // backwards compatibility fix (rendering issue)
                lineHeight: '1'
            })
	        .addClass('boxToBorderSize');
    };

    Drop.extend(BoolInput, Drop);

    BoolInput.typeName = 'BoolInput';

    BoolInput.prototype.renderCheckbox = function () {
        this.$checkbox = $('<input type = "checkbox" />')
            .prop('checked', this.data.defaultValue)
            .attr('name', this.data.name)
            .attr('tabindex', this.data.tabIndex)
            .attr('title', this.data.tooltip)
            .css({
                margin: '0'
            });

        if (this.data.useBuiltInStyle) {
            this.$checkbox
                .appendTo(this.$element);
        } else {
            this.$wrapper = $('<label class="customCheckState" />')
                .append(this.$checkbox)
                .append($('<div class="drop-text-content customCheckState-tick"></div>')
                    .append($('<div>&#x2714</div>')))
                .appendTo(this.$element);

            Style.renderStyles(this, null, this.$wrapper);
        }

        var self = this;
        this.$checkbox.on('change', function () {
            var isChecked = self.$checkbox.is(':checked');
            self.triggerEventIfEnabled('toggled', isChecked);
            self.triggerEventIfEnabled(isChecked ? 'checked' : 'unchecked');
        });
    };

    BoolInput.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
        this.initialize();
    };

    BoolInput.prototype.initialize = function () {
        if (this.data.readOnly)
            this.$checkbox.prop('disabled', true);
    };

    BoolInput.prototype.getValue = function () {
        return this.$checkbox.is(':checked');
    };

    BoolInput.prototype.clearValue = function () {
        this.$checkbox.prop('checked', false);
    };

    BoolInput.prototype.setValue = function (update) {
        this.$checkbox.prop('checked', this.isTrue(update));
    };

    BoolInput.prototype.isTrue = function (update) {
        return update.value === true ||
            (update.type === constants.valueTypes.string
                && update.value
                && update.value.toString().toLowerCase() === 'true');
    };
    
    return BoolInput;
});
